import '@zebra-fed/icons/Enterprise/index.css';
import Snackbar from '@material-ui/core/Snackbar';
import { Button, Icon } from '@zebra-fed/zds-react-desktop';
import MaterialTable from 'material-table';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { AuthContext } from '../../../authentication/Auth';
import app from '../../../authentication/firebaseStart';
import AddUserModal from '../../../components/modals/AddUserModal';
import ChangePasswordModal from '../../../components/modals/ChangePasswordModal';
import ConfirmModal from '../../../components/modals/ConfirmModal';
import firebaseUtil from '../../../data/FirebaseUtil';
import { ContentWrapper, PageTitle, SnackbarContent } from '../../../styled-components/shared';
import Pagination from './components/Pagination';
import { tableIcons } from './components/TableIcons';
import Toolbar from './components/Toolbar';
import Moment from 'react-moment';
import moment from 'moment';
import config from '../../../data/application.properties'
import BottomNavLinks from "../../../components/BottomNavLinks";
import { useTranslation } from "react-i18next";
const firestore = app.firestore();
const MainContent = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
`;
const StyledHeader = styled(PageTitle)`
  // min-width: 1020px;
`;
const TableHeader = styled.h1`
  font-size: 20px;
`;
let locations = [];

const defaultDate = moment().subtract(0,"day").valueOf();
var searchparam =  {
  // fromDate : moment().subtract(1,"day").valueOf(),
  // toDate: moment().valueOf(),
  fromDate : defaultDate,
  toDate: defaultDate, //Fix for DLM-10756: we force the toDate as the same as fromDate since only fromData is avaiable in UI.
  siteName: ""
}
export default function ManageUsersPage(props) {
  const SUPER_ADMIN = 'superAdmin';
  const DEFAULT_ROWS_PER_PAGE = 100;
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [snackbarVisible, setSnackBarVisible] = useState(false);
  const [snackbarMessage, setSnackBarMessage] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemCount, setItemCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [deletedUser, setDeletedUser] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [siteName, setSiteName] = useState('');
  const context = useContext(AuthContext);
  const modalRef = useRef();
  const addUserModalRef = useRef();
  const confirmModalRef = useRef();
  const {t} = useTranslation();
  useEffect(() => {
    setLoggedInUser(context.currentUser.email);
    getData(pageSize);
    getLocations(pageSize);
    
  }, []);
  async function getData(currentPageSize) {
    let itemsPerPage = currentPageSize; /* Should be fetched dynamically from UI */
    let companyID = context.currentUser.claims.companyID;
    let isSuperAdmin = context.currentUser.claims.isSuperAdmin;
    let totalCount = 0;
    var url = `https://${config.FIRESTORE_HOSTED_REGION}-emc-zdtrk-research-d.cloudfunctions.net/getCheckoutLogs?datefrom=1609477200000&dateto=1631797926261`;
    
    
    
    console.log('searchparam',searchparam);
    
    
    // setItemCount(isSuperAdmin === true ? totalCount : totalCount - 1);
    setIsLoading(true);
    getLocations(pageSize);
    let tabledata = [];
    // await fetch(url)
    // .then(response => response.json())
    // .then(data => {
    //   console.log("Got data");
    //   console.log(data) 
    //   tabledata=data;
    // });
    console.log("Search Params",searchparam);
    var params = {
      dateFrom: moment(searchparam.fromDate).startOf('day').format("YYYY-MM-DD"),
      // dateTo: moment(searchparam.toDate).endOf('day').valueOf(),
      maxResults: 29999,
      offset: 0
      // checkoutOnly: false
    }
    if (searchparam.siteName!=""  && searchparam.siteName!="All"){
      params.siteName = searchparam.siteName;
    }
    console.log("Params",params)
    await firebaseUtil
      .getSnapshotData(params)
      .then((response) => {
        console.log("success",response)
        tabledata=response.data
      })
      .catch((err) => {
        console.log("Error",err)
      });
    // if (!isSuperAdmin) {
    //   users = (
    //     await firestore
    //       .collection('tenants')
    //       .doc(companyID)
    //       .collection('Users')
    //       .where('accessType', 'in', ['admin', 'manager'])
    //       .orderBy('reportedAt', 'desc')
    //       .limit(itemsPerPage)
    //       .get()
    //   ).docs.map((doc) => doc.data());
    // } else {
    //   users = (
    //     await firestore
    //       .collection('tenants')
    //       .doc(companyID)
    //       .collection('Users')
    //       .orderBy('reportedAt', 'desc')
    //       .limit(itemsPerPage)
    //       .get()
    //   ).docs.map((doc) => doc.data());
    // }
    console.log(tabledata);
    setIsLoading(false);
    setCurrentPage(0);
    setData(tabledata);
  }
  async function getLocations(currentPageSize) {
    let itemsPerPage = currentPageSize; /* Should be fetched dynamically from UI */
    let companyID = context.currentUser.claims.companyID != null ? context.currentUser.claims.companyID : config.TENANT_ID;
    let isSuperAdmin = context.currentUser.claims.isSuperAdmin;
    
    locations = (
      await firestore
        .collection('tenants')
        .doc(companyID)
        .collection('SiteLocations')
        .orderBy('displaySiteName', 'asc')
        .get()
    ).docs.map((doc) => doc.data());
    locations.unshift( {
      "displaySiteName":"All",
      "siteName":"All"
    } )    
    console.log("Got locations",locations);
  }
  function onModalClose(modalType) {
    if (modalType === 'add user') {
      setError(false);
      setSnackBarMessage('User added successfully');
      getData(pageSize);
    } else {
      setError(false);
      setSnackBarMessage('Password changed successfully');
    }
    setSnackBarVisible(true);
  }
  async function next() {
    let itemsPerPage = pageSize;
    let startDoc = data[data.length - 1].reportedAt;
    let companyID = context.currentUser.claims.companyID;
    let isSuperAdmin = context.currentUser.claims.isSuperAdmin;
    setIsLoading(true);
    let users = [];
    if (!isSuperAdmin) {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('accessType', 'in', ['admin', 'manager'])
          .orderBy('reportedAt', 'desc')
          .startAfter(startDoc)
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    } else {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .orderBy('reportedAt', 'desc')
          .startAfter(startDoc)
          .limit(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    }
    setIsLoading(false);
    setData(users);
    setCurrentPage(currentPage + 1);
  }
  async function prev() {
    let itemsPerPage = pageSize; /* Should be fetched dynamically from UI */
    let startDoc = data[0].reportedAt; /* First user emailId from the current users list */
    let companyID = context.currentUser.claims.companyID;
    let isSuperAdmin = context.currentUser.claims.isSuperAdmin;
    setIsLoading(true);
    let users = [];
    if (!isSuperAdmin) {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('accessType', 'in', ['admin', 'manager'])
          .orderBy('reportedAt', 'desc')
          .endBefore(startDoc)
          .limitToLast(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    } else {
      users = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .orderBy('reportedAt', 'desc')
          .endBefore(startDoc)
          .limitToLast(itemsPerPage)
          .get()
      ).docs.map((doc) => doc.data());
    }
    setIsLoading(false);
    setData(users);
    setCurrentPage(currentPage - 1);
  }
  function handleDeleteUser(emailId) {
    setIsLoading(true);
    firebaseUtil
      .deleteUser({ email: emailId })
      .then((response) => {
        setError(!response.status);
        setSnackBarVisible(true);
        setSnackBarMessage(response.msg);
        setDeletedUser(null);
        setSearchText('');
        getData(pageSize);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(!err.status);
        setSnackBarVisible(true);
        setSnackBarMessage(err.msg);
        setDeletedUser(null);
        getData(pageSize);
        setIsLoading(false);
      });
  }
  async function searchByEmailId(emailId) {
    try {
      setIsLoading(true);
      let companyID = context.currentUser.claims.companyID;
      let user = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('emailId', '==', emailId.toLowerCase())
          .get()
      ).docs.map((doc) => doc.data());
      setData(user);
      setItemCount(user.length);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setItemCount(0);
      setData([]);
    }
  }
  return (
    <>
      <ContentWrapper>
        <StyledHeader>
        End of Day Device Detail
          {/* <Button
            type="primary"
            dense={true}
            style={{ margin: 0 }}
            onClick={() => addUserModalRef.current.toggleDialog()}
          >
            Export
          </Button> */}
        </StyledHeader>
        <MainContent>
          <MaterialTable
            columns={[
              { title: 'Model', field: 'modelNumber', sorting: false },
              { title: 'Serial', field: 'serialNumber', sorting: false },
              { title: 'Friendly Name', field: 'friendlyName', sorting: false },
              { title: 'User Id', field: 'userId', sorting: false },
              { title: 'Time Since User Checked Out', field: 'timeSinceUserCheckedOut', sorting: false },
              { title: 'Exceeds Allowed Time', field: 'maxCheckoutTimePassed', sorting: false },
              { title: 'Site', field: 'siteName', sorting: false },
              { title: 'AP Friendly Name', field: 'apFriendlyName', sorting: false },
               
            ]}
            options={{
              actionsColumnIndex: 2,
              paginationType: 'stepped',
              search: true,
              minBodyHeight: '250px',
              maxBodyHeight: '400px',
              paging: itemCount > DEFAULT_ROWS_PER_PAGE ? true : false,
              pageSize: DEFAULT_ROWS_PER_PAGE,
              pageSizeOptions: [10, 25, 50, 100],
              cspNonce: window.NONCE_ID,
            }}
            icons={tableIcons}
            isLoading={isLoading}
            // actions={[
            //   (rowData) => ({
            //     hidden: rowData.accessType === SUPER_ADMIN || rowData.emailId === loggedInUser,
            //     icon: () => {
            //       return <Icon name={'delete'} category={'general'} color="#8e8e8e" size={18} />;
            //     },
            //     onClick: (event, rowData) => {
            //       setDeletedUser(rowData.emailId);
            //       confirmModalRef.current.toggleDialog();
            //     },
            //     tooltip: 'Delete user',
            //   }),
            // ]}
            components={{
              Pagination: (props) => (
                <Pagination
                  {...props}
                  itemCount={itemCount}
                  currentPage={currentPage}
                  onNextClicked={next}
                  onPrevClicked={prev}
                />
              ),
              Toolbar: (props) => (
                <Toolbar
                  searchText={searchText}
                  fromDate={searchparam.fromDate}
                  toDate={searchparam.toDate}
                  siteName={searchparam.siteName}
                  locations={locations}
                  onFromDateChange={(date) => {
                    if (date != '') {
                      console.log('DateFrom ' + date);
                      searchparam.fromDate = date; //moment(date).valueOf();
                      searchparam.toDate = searchparam.fromDate; // Fix for DLM-10756: default: moment(date).valueOf(); we force searchparam.toDate is the same as  searchparam.fromDate
                      getData(pageSize);
                    }
                  }}
                  // onToDateChange={(date) => {
                  //   if (date != '') {
                  //     console.log('DateTo' + date);
                  //     searchparam.toDate = date; //moment(date).valueOf();
                  //     getData(pageSize);
                  //   }
                  // }}
                  onSiteNameChange={(event) => {
                    if (event.target.value != '') {
                      console.log('SiteName',event.target.value);
                      searchparam.siteName = event.target.value;
                      getData(pageSize);
                    }
                  }}                  
                  onSearch={(searchVal) => {
                    if (searchVal != '') {
                      setSearchText(searchVal);
                      console.log('Search ' + searchVal);
                      searchByEmailId(searchVal);
                    }
                  }}
                  onClear={(searchVal) => {
                    console.log('Reset ' + searchVal);
                    setSearchText('');
                    getData(pageSize);
                  }}
                />
              ),
            }}
            // onChangeRowsPerPage={(val) => {
            //   setPageSize(val);
            //   getData(val);
            // }}
            localization={{
              body: {
                emptyDataSourceMessage: t('messages.error.err26'),
              },
            }}
            data={data}
          />
        </MainContent>
        <BottomNavLinks />
        <ChangePasswordModal
          modalRef={modalRef}
          currentUser={currentUser}
          onClose={() => onModalClose('change password')}
        />
        <AddUserModal modalRef={addUserModalRef} onClose={() => onModalClose('add user')} />
        <ConfirmModal
          modalRef={confirmModalRef}
          title={'Delete User'}
          message={`Are you sure you want to delete ${deletedUser}?`}
          onClose={() => {
            confirmModalRef.current.toggleDialog();
            handleDeleteUser(deletedUser);
          }}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={snackbarVisible}
          autoHideDuration={5000}
          onClose={() => setSnackBarVisible(false)}
        >
          <SnackbarContent error={error}>{snackbarMessage}</SnackbarContent>
        </Snackbar>
      </ContentWrapper>
    </>
  );
}